import React from 'react';
import { Globe2, BrainCircuit, TrendingUp } from 'lucide-react';
import Reveal from './Reveal';

const VISION_ICONS = [Globe2, BrainCircuit, TrendingUp];

export default function Vision({ t }) {
  const v = t.vision;

  return (
    <section className="relative bg-abyss py-24 lg:py-32 overflow-hidden">
      <div className="absolute top-1/3 -left-32 w-[460px] h-[460px] rounded-full bg-volt-400/8 blur-[150px] pointer-events-none" />
      <div className="absolute bottom-0 -right-32 w-[420px] h-[420px] rounded-full bg-pulse-500/10 blur-[150px] pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Vision */}
        <Reveal>
          <div className="text-center max-w-3xl mx-auto mb-16">
            <span className="inline-block px-4 py-1.5 rounded-full border border-pulse-400/40 bg-pulse-500/10 text-pulse-400 text-xs font-bold uppercase tracking-[0.18em] mb-5">
              {v.kicker}
            </span>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-frost tracking-tight leading-tight">
              {v.title}
            </h2>
            <p className="mt-6 font-display text-xl sm:text-2xl text-volt-400 font-medium leading-relaxed">
              “{v.statement}”
            </p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {v.cards.map((card, i) => {
            const Icon = VISION_ICONS[i];
            return (
              <Reveal key={card.title} delay={i * 90}>
                <div className="group h-full rounded-3xl border border-line bg-surface p-8 text-center hover:border-volt-400/40 hover:-translate-y-1 transition-all duration-300">
                  <div className="mx-auto w-14 h-14 rounded-2xl bg-gradient-to-br from-volt-400/20 to-pulse-500/20 border border-line flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                    <Icon size={24} className="text-volt-400" />
                  </div>
                  <h3 className="font-display text-xl font-bold text-frost mb-3">{card.title}</h3>
                  <p className="text-sm text-mist leading-relaxed">{card.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
